import api from 'service/api'

const dponetAPI = api.create('dponet')

const getGapStats = async () => {
  return await dponetAPI.get('/dashboard/gap_stats')
}

const getGeneralStats = async () => {
  return await dponetAPI.get('/dashboard/general_stats')
}

const getSupplierStats = async () => {
  return await dponetAPI.get('/dashboard/supplier_stats')
}

const getProcessStats = async () => {
  return await dponetAPI.get('/dashboard/data_process_stats')
}

const getFragilityStats = async () => {
  return await dponetAPI.get('/dashboard/fragility_stats')
}

const getQuestionControlStats = async () => {
  return await dponetAPI.get('/dashboard/question_control_stats')
}

const getConsentStats = async () => {
  return await dponetAPI.get('/dashboard/consent_stats')
}

const getPrivacyPolicyStats = async () => {
  return await dponetAPI.get('/dashboard/privacy_policy_stats')
}

const getTicketStats = async () => {
  return await dponetAPI.get('/dashboard/ticket_stats')
}

const getComplaintStats = async () => {
  return await dponetAPI.get('/dashboard/complaint_stats')
}

const getTrainingStats = async () => {
  return await dponetAPI.get('/dashboard/training_stats')
}

export default {
  getComplaintStats,
  getConsentStats,
  getFragilityStats,
  getGapStats,
  getGeneralStats,
  getPrivacyPolicyStats,
  getProcessStats,
  getQuestionControlStats,
  getSupplierStats,
  getTicketStats,
  getTrainingStats,
}
